var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4C8.08128 4 4.5 7.58128 4.5 12C4.5 16.4187 8.08128 20 12.5 20C16.9187 20 20.5 16.4187 20.5 12C20.5 7.58128 16.9187 4 12.5 4ZM2.5 12C2.5 6.47672 6.97672 2 12.5 2C18.0233 2 22.5 6.47672 22.5 12C22.5 17.5233 18.0233 22 12.5 22C6.97672 22 2.5 17.5233 2.5 12ZM12.5 5C13.0523 5 13.5 5.44772 13.5 6V11H16.5C17.0523 11 17.5 11.4477 17.5 12C17.5 12.5523 17.0523 13 16.5 13H12.5C11.9477 13 11.5 12.5523 11.5 12V6C11.5 5.44772 11.9477 5 12.5 5Z",
    fill: "#646D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ffb898582727610350e0d02fb650fa70.svg";
export { ForwardRef as ReactComponent };